import { Box } from '@mui/material'

type FormattedRichTextBoxProps = {
  htmlContent: string | null | undefined
  className?: string
}

export function FormattedRichTextBox(props: FormattedRichTextBoxProps) {
  const { htmlContent, className } = props
  return (
    <Box
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: htmlContent ?? '' }}
      className={className}
    />
  )
}
